import React from 'react';
import ClientTabbedForm from './ClientTabbedForm';
import { ClientFormContextProvider } from './ClientFormContext';

const ClientFormContainer: React.FC = (): React.ReactElement => {
    return (
        <ClientFormContextProvider>
            <ClientTabbedForm />
        </ClientFormContextProvider>
    );
};

export default ClientFormContainer;
